import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './template.css'
import { ReactComponent as Logo } from '../assets/smLogo.svg'
import { HashLink as Link } from 'react-router-hash-link';

const TitleThreeColumn = ({ columnsData }) => {
  return (
    <div className={("title-threeColumn " + columnsData.class)}>
      {columnsData.title && columnsData.title.text && <h1 className={columnsData.title.class}>{columnsData.title.text}</h1>}
      <div className={"title-threeColumn-columns"}>
        {columnsData.columns.length > 0 && columnsData.columns.map((column, idx) => <Column key={idx} column={column} />)}
      </div>
    </div>
  )
}

const Column = ({ column }) => {
  let renderIcon = ({ icon }) => {
    if (icon.src === "dark-logo") {
      return (<Logo alt="Dark logo" className={"title-threeColumn-icon dark-logo-icon"} />)
    } else {
      return (<FontAwesomeIcon className={("title-threeColumn-icon " + icon.class || "")} icon={icon.src} />)
    }
  }
  let topContent = () => {
    let icon = (column.icon && column.icon.src && renderIcon(column))
    if (column.link && column.link.url) {
      return (column.link.external? <a target="_blank" rel="noopener noreferrer" className={("title-threeColumn-link block " + column.link.class || "")} href={column.link.url}>
      {icon}
      <p>{column.link.text}</p></a> : <Link className={("title-threeColumn-link block " + column.link.class || "")} to={column.link.url}>
        {icon}
        <p>{column.link.text}</p></Link>
      )
    } else {
      return ({ icon })
    }
  }

  return (
    <div className={"title-threeColumn-column"}>
      {topContent()}
      {column.title && column.title.text && <h2 className={("small-title " + column.title.class || "")}>{column.title.text}</h2>}
      {column.paragraph && column.paragraph.text && <p className={column.paragraph.class || ""}>{column.paragraph.text}</p>}
    </div>
  )
}

export default TitleThreeColumn